import ErrorFallback from 'Components/ErrorFallback'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import {
  ZoneDefinitionCreatePage,
  ZoneDefinitionEditPage,
  ZoneDefinitionListPage
} from 'Services/ProductManagement/Features/ZoneDefinition/Pages'
import useTypedSelector from 'Store'
import { LOGIN_PAGE_PATH } from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

export function ZoneDefinitionRoot() {
  const { user } = useTypedSelector(state => state.user)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ZoneDefinitionListPage />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={true}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
        >
          <Route path=":id/edit" element={<ZoneDefinitionEditPage />} />
          <Route path="create" element={<ZoneDefinitionCreatePage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}
